{
  "action": {
    "addPrice": "Add a new price",
    "stopMerge": "Stop merging"
  },
  "backButtonTitle": {
    "backButtonLabel": {
      "backToLocations": "Back to locations list"
    },
    "title": {
      "addClosedDate": "Add a closed date",
      "addEmployee": "Add an employee",
      "addLocation": "Add a location",
      "addMachine": "Add a machine",
      "addRegion": "Add a region",
      "addService": "Add a service",
      "addTimetable": "Add a timetable",
      "addWorkplace": "Add a workplace",
      "edit": "Edit",
      "newTimetable": "New recurring timetable",
      "newTimetableException": "New Timetable exception"
    }
  },
  "book": {
    "bookCard": {
      "button": {
        "book": "Book online",
        "discover": "Discover"
      }
    },
    "text": "{weeezy} already counts many vendors whose services may interest you. Look it up !",
    "title": "Book right now !"
  },
  "booking": {
    "AdditionalServices": "Additional services",
    "addAnEvent": {
      "customerAppointment": "",
      "event": "Private event",
      "title": "Add an event",
      "type": "Event type"
    },
    "at": "at",
    "closing": {
      "careful": "Careful",
      "expressTitle": "Closing without booking",
      "fidelityVoucher": "Loyalty voucher",
      "giftAlreadyUsed": "Voucher already used in this closing",
      "giftCards": "Gift cards",
      "giftUuidTooLong": "",
      "negativePaymentWarning": "There are some negative payment, would you like to verify them ?",
      "overPaid": "Over paid amount",
      "payments": "Payments",
      "price": "Price",
      "show": "Showed",
      "start": "Start",
      "title": "Closing",
      "titleModify": "Modify closing",
      "total": "Total"
    },
    "completeProfileHint": "To confirm your booking, please add your {fields}.",
    "completeProfileTitle": "Complete your profile",
    "history": "Service history",
    "outOfSchedule": "out of schedule",
    "sendConfirmationEmail": "Send confirmation email",
    "stepComment": "Comment",
    "stepCustomer": "Customer",
    "stepDate": "Date",
    "stepMyAccount": "My account",
    "title": "New Booking",
    "titleAdd": "New booking",
    "titleEdit": "Edit booking"
  },
  "bookingConfirmation": {
    "doneBy": "Done by",
    "from": "from",
    "title": "Booking saved | Bookings saved",
    "to": "until"
  },
  "bookingSelectModal": {
    "title": "Chose your prefered option"
  },
  "bookingStatus": {
    "canceled": "Canceled",
    "executed": "Executed",
    "noShow": "No show",
    "open": "Open"
  },
  "bookingStepChange": {
    "bookingVerifyError": ""
  },
  "bookingStepDate": {
    "choseDate": "Select the date",
    "choseTime": "Select the time",
    "subtitle": "",
    "tip": "",
    "title": ""
  },
  "bookingStepDateTimeSlots": {
    "none": ""
  },
  "bookingStepPlace": {
    "indication": "",
    "location": "Location",
    "services": "Treatments"
  },
  "bookingStepPlaceServices": {
    "eraseFilter": "",
    "search": ""
  },
  "bookingStepVerification": {
    "comment": "Comment",
    "doneBy": "",
    "legalConditionsIndications": "Please read and agree to the terms below.",
    "legalConditionsTitle": "General Terms",
    "title": ""
  },
  "bookingSummary": {
    "from": "",
    "none": "",
    "remove": "",
    "title": "",
    "to": ""
  },
  "bookingView": {
    "cancelMessage": "Message in"
  },
  "button": {
    "about": "About",
    "add": "Add",
    "addArticle": "Add article",
    "addService": "Add service",
    "addTimeRange": "Add a work block",
    "back": "Back",
    "bookAppointment": "Book appointment",
    "cancel": "Cancel",
    "cancelBooking": "Cancel booking",
    "cash": "Cash",
    "cc": "Debit/credit card",
    "close": "Close",
    "closeBooking": "Close",
    "closeFrom": "Plan closing",
    "closeNoShow": "No show",
    "complete": "Complete",
    "confirm": "Confirm",
    "confirmBooking": "Confirm booking",
    "confirmTimetableAdd": "",
    "confirmTimetableCancel": "Confirm timetable deletion",
    "contact": "Contact",
    "copied": "Copied",
    "createNewEmployee": "Create a new employee",
    "createNewEvent": "Add Event",
    "createNewLocation": "Create a new location",
    "createNewRegion": "Create a new region",
    "createNewResource": "Create a new resource",
    "createNewService": "Create a new service",
    "createNewWorkplace": "Create a new workplace",
    "delete": "Delete",
    "done": "Done",
    "download": "Download",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "end": "Done",
    "endProcess": "Back to account",
    "getStarted": "Let's go!",
    "goTo": "Go to",
    "hideDetails": "Hide details",
    "ignore": "Ignore",
    "later": "Later",
    "leave": "Leave",
    "login": "Sign in",
    "merge": "Merge",
    "modify": "Modify",
    "modifyClose": "Edit closing",
    "more": "More info",
    "new": "New",
    "newBooking": "Customer appointment",
    "newBreak": "Break",
    "newEvent": "Private",
    "newTransport": "Transport",
    "next": "Next",
    "open": "Open",
    "pay": "Pay",
    "plan": "Plan",
    "postfinance": "Postcard",
    "previous": "Back",
    "refresh": "Refresh",
    "reset": "Reset",
    "retry": "Retry",
    "save": "Save",
    "send": "Send",
    "showDetails": "Show details",
    "today": "Today",
    "translate": "Translate",
    "verify": "Verify",
    "view": "View"
  },
  "calendar": {
    "actualBloc": "",
    "capacityThreshold": "The {actualBloc} must be full at {capacityThreshold} for the other bloc to open.",
    "eventResourcesFailed": "Locations and workplaces could not be loaded: appointments are shown without their colour.",
    "group": "Group",
    "individual": "Individual",
    "sync": {
      "addToIOS": "Add to my ipHone / iPad",
      "addToMac": "Add to my Mac",
      "footer": "",
      "googleCalendarGuide": "Google Calendar Guide",
      "googleCalendarGuideInfo": "",
      "googleCalendarGuideStep1": "",
      "googleCalendarGuideStep2": "",
      "googleCalendarGuideStep3": "",
      "howItWorks": "How does it work?",
      "ical": "iCal Feed",
      "outlookGuide": "Outlook Guide (Add Internet calendars)",
      "paragraph1": "Sync Weeezy calendar with your personal one.",
      "quickAccess": "Quick access",
      "title": "Calendar sync"
    }
  },
  "cardStatus": {
    "active": "Active",
    "expired": "Expired",
    "inProgress": "Available soon",
    "partiallyUsed": "Partially used",
    "used": "Used"
  },
  "category": {
    "automatic": "Automatic",
    "manual": "Manual"
  },
  "checkEventsConflictsModal": {
    "addClosedData": {
      "title": "Add closed date"
    },
    "addClosedForm": {
      "title": "Plan closing"
    },
    "addTimetableException": {
      "title": ""
    },
    "cancelMessage": "Cancellation message",
    "cancelMessageHelp": "Please explain the reason for this cancellation",
    "conflicts": "There are conflicts with existing bookings. Please resolve them before submitting them.",
    "customers": {
      "title": "Delete customer"
    },
    "deleteAllEvents": "Cancel all events",
    "editClosedDate": {
      "title": "Edit closed date"
    },
    "inputErrors": "You have errors in the data entered, please correct them and try again.",
    "noConflicts": "There are no conflicts with existing events. You can end the action by clicking on the {buttonTitle} button.",
    "services": {
      "title": "Modify a service"
    },
    "timetableExceptions": {
      "title": "Delete a special timetable"
    },
    "timetables": {
      "title": "Delete a timetable"
    },
    "workplaces": {
      "delete": {
        "title": "Delete workplace"
      },
      "modify": {
        "title": "Modify workplace"
      }
    }
  },
  "closedBookings": {
    "none": "No closed booking",
    "title": "Closed Bookings"
  },
  "closedDateForm": {
    "location": {
      "label": "Locations"
    }
  },
  "closedDates": {
    "title": "Closed days"
  },
  "columnHeader": {
    "amount": "Amount",
    "balance": "Balance",
    "customer": "Customer",
    "date": "Date",
    "employee": "Employee",
    "faceValue": "Face value",
    "method": "Method",
    "no": "No",
    "paid": "Paid",
    "payment": "Payment",
    "price": "Price",
    "quantity": "Quantity",
    "services": "Treatments",
    "status": "Status",
    "total": "Total",
    "uuid": "Code",
    "validUntil": "Valid until",
    "wording": "Wording"
  },
  "configError": {
    "closedDateLocations": "This closed date will not be used until it has at least one location assigned.",
    "employeeServices": "This employee will not be available for a booking until she has at least one department assigned.",
    "employeeServicesWorkplaces": "At least one service from this employee can't be booked : there is no match between the employee's workplaces and the service's workplaces.",
    "employeeWorkplaces": "This employee will not be available for a booking until he has at least one workplace assigned.",
    "locationRegion": "This location will not be available for a booking until it has a region assigned.",
    "machineServices": "This resource is not assigned to any service.",
    "machineWorkplaces": "This resource is not assigned to any workplace.",
    "regionLocations": "At least one location must be assigned to this region to be used.",
    "serviceEmployees": "This service will not be available for a booking until it has at least one employee assigned.",
    "serviceWorkplaces": "This service will not be available for a booking until it has at least one workplace assigned.",
    "title": "Configuration issue",
    "workplaceEmployees": "This workplace will not be used until it has at least one employee assigned.",
    "workplaceServices": "This workplace will not be used until it has at least one service assigned."
  },
  "confirmModal": {
    "cancelBooking": {
      "message": "Please confirm the cancellation of the appointment starting at {startTime} on the {startDate} using the \"Cancel Booking\" button below."
    },
    "deleteBooking": "confirmModal.deleteBooking",
    "deleteClosedBooking": {
      "message": "Please confirm the deletion of the appointment starting at {startTime} on the {startDate} using the \"Delete Booking\" button below."
    },
    "deleteClosedDate": {
      "message": "Please confirm the deletion of the closing day {date} {summary} using the \"Delete\" button below."
    },
    "deleteComment": {
      "message": "Please confirm the deletion of the comment from {commentAuthor} using the \"Delete\" button below."
    },
    "deleteEvent": "Please confirm the deletion of the event using the \"Delete\" button below.",
    "deleteInvoice": {
      "message": "Please confirm the deletion of the invoice #{number} using the \"Delete\" button below."
    },
    "deleteLocation": {
      "message": "Please confirm the deletion of the location {locationName} using the \"Delete\" button below."
    },
    "deleteMachine": {
      "message": "Please confirm the deletion of the resource {machine} using the \"Delete\" button below."
    },
    "deleteMachineModel": {
      "message": "Please confirm the deletion of the model {machineModel} using the \"Delete\" button below."
    },
    "deleteRegion": {
      "message": "Please confirm the deletion of the region {regionName} using the \"Delete\" button below."
    },
    "deleteService": {
      "message": "If there are bookings with this service, they will be kept.<br />Please confirm the deletion of the service <b>{serviceName}</b> with the button \"Delete\" below."
    },
    "locationReopen": {
      "message": "Reopen {location}"
    },
    "revokingSlack": {
      "message": "Do you really want to revoke your Slack integration for your team {team}?"
    },
    "title": "Confirmation"
  },
  "conflictEventAction": {
    "cancelEvent": "Cancel event",
    "checkDetails": "Check details",
    "createTimetableException": "Keep existing timetable for this date"
  },
  "customerComment": {
    "add": "Add a comment",
    "edit": "Edit a comment",
    "editedBy": "Edited by {name} on {date}",
    "empty": "No comment",
    "title": "Private comments"
  },
  "customerForm": {
    "addTitle": "Add a customer",
    "editTitle": "Edit a customer",
    "passwordPlaceholder": "Leave empty if unchanged"
  },
  "customerView": {
    "mr": "Mr.",
    "mrs": "Mrs.",
    "pageTitle": "Customer Account",
    "private": "Private",
    "professional": "Pro",
    "stats": {
      "cancelled": "Cancelled",
      "noShow": "No show",
      "unpaid": "unpaid"
    },
    "title": "Customer file"
  },
  "customersMerge": {
    "confirm": "Confirm merge",
    "conflicts": "Some fields are in conflict, please select the correct value. You can still edit the customer account after the merge if no value matches.",
    "loadFailed": "Unable to load the customers to merge.",
    "mergeFailed": "The customer merge failed.",
    "noConflict": "No other conflict to report.",
    "title": "Merge customers",
    "userAccountKept": "The password and username linked to this account will be kept.",
    "warning": "This action is final and cannot be undone. Please confirm the merge with the \"Merge\" button."
  },
  "deviceSessions": {
    "changeTitle": "Change your PIN",
    "chooserHelp": "Employees are signed in on this device. Pick yours and enter your PIN.",
    "chooserTitle": "Resume a session",
    "expired": "This employee's session has expired on this device, they must log in with their password.",
    "logMeIn": "Log me in",
    "logoutDevice": "Log everyone out",
    "pin": "PIN",
    "pinHint": "Six digits, no sequence or repetition.",
    "pinOf": "{name}'s PIN",
    "saved": "Your PIN has been saved.",
    "setupHelp": "This device is shared with your colleagues. Your PIN returns you to your session without typing your password every time.",
    "setupTitle": "Set your PIN",
    "switch": "Switch employee",
    "title": "Switch employee"
  },
  "emailValidation": {
    "loaderLabel": "Confirmation"
  },
  "employeeForm": {
    "basics": {
      "title": "User data"
    },
    "invitationEmail": {
      "help": "Optional. The employee receives a link to create an account or link the one they already have.",
      "label": "Invitation e-mail"
    },
    "nonPreferredServices": {
      "label": "Non priority services",
      "labelTooltip": "When making an appointment, an employee will be NON PRIORITY and will only be offered to perform these treatments if no priority employee is available."
    },
    "nonPreferredWorkplaces": {
      "label": "Non priority workplaces",
      "labelTooltip": "The room can only be occupied by this employee if the priority employees are not available."
    },
    "preferredServices": {
      "label": "Priority services",
      "labelTooltip": "When making an appointment, the employee will be given PRIORITY and will always be offered to carry out this care if available."
    },
    "preferredWorkplaces": {
      "label": "Priority workplaces",
      "labelTooltip": "The room can only be occupied by this employee if available."
    },
    "removedServicesWarning": "If future appointments with this employee using these services are made, they will be kept. Services :",
    "removedWorkplacesWarning": "If future appointments with this employee use these workplaces, they will be kept. Workplaces :",
    "requiredLocationsRemovedMessage": "The employee has defined timetables with a missing location. Please ensure that these locations are associated with the employee or change the timetables in advance.",
    "timetableExceptionLocations": "The timetable exception from {date} uses the following locations:",
    "timetableLocations": "The timetable starting at {validFrom} uses the following locations:"
  },
  "emptyDataset": {
    "closedDate": "No business holidays planned",
    "default": "No results",
    "location": "No locations",
    "planning": "Your planning is empty",
    "region": "No regions",
    "service": "No services",
    "workplaces": "No workplaces"
  },
  "error": {
    "imageLoadFailed": "Unable to load image",
    "unexpectedApiResponse": "Unexpected response from the API"
  },
  "fetchFailure": {
    "customerView": "An error occurred on loading the customer account."
  },
  "fidelityVouchers": {
    "alreadyAccumualted": "No amount accumulated. | CHF {n} accumulated.",
    "expired": "Expired",
    "nextVoucher": "Voucher received. | Next voucher after next booking. | Next voucher in {n} bookings.",
    "none": "No loyalty voucher",
    "title": "Loyalty Vouchers",
    "use": "Use loyalty voucher",
    "valid": "Valid"
  },
  "filePond": {
    "acceptedFormats": "Accepted formats",
    "dimensionRange": "Dimensions",
    "fileCount": "Single file only | Maximum {count} files",
    "imageValidateSizeLabelExpectedMaxSize": "Maximum size: ",
    "imageValidateSizeLabelExpectedMinSize": "Minimum size: ",
    "imageValidateSizeLabelFormatError": "Image format is not valid",
    "imageValidateSizeLabelImageResolutionTooHigh": "Resolution is too high",
    "imageValidateSizeLabelImageResolutionTooLow": "Resolution is too low",
    "imageValidateSizeLabelImageSizeTooBig": "Image is too big",
    "imageValidateSizeLabelImageSizeTooSmall": "Image is too small",
    "labelButtonAbortItemLoad": "Abort",
    "labelButtonAbortItemProcessing": "Cancel",
    "labelButtonProcessItem": "Upload",
    "labelButtonRemoveItem": "Remove",
    "labelButtonRetryItemLoad": "Retry",
    "labelButtonRetryItemProcessing": "Retry",
    "labelButtonUndoItemProcessing": "Undo",
    "labelDecimalSeparator": ".",
    "labelFileLoadError": "Error during load",
    "labelFileLoading": "Loading",
    "labelFileProcessing": "Uploading",
    "labelFileProcessingAborted": "Upload cancelled",
    "labelFileProcessingComplete": "Upload complete",
    "labelFileProcessingError": "Error during upload",
    "labelFileProcessingRevertError": "Error during revert",
    "labelFileRemoveError": "Error during remove",
    "labelFileSizeNotAvailable": "Size not available",
    "labelFileWaitingForSize": "Waiting for size",
    "labelIdle": "Drag & Drop your files or <span class=\"filepond--label-action\">Browse</span>",
    "labelInvalidField": "Field contains invalid files",
    "labelTapToCancel": "tap to cancel",
    "labelTapToRetry": "tap to retry",
    "labelTapToUndo": "tap to undo",
    "labelThousandsSeparator": ",",
    "maxDimension": "Maximum dimension",
    "maxSize": "Maximum size",
    "minDimension": "Minimum dimension",
    "perFile": "per file"
  },
  "forgotPassword": {
    "title": "Reset your password"
  },
  "formInput": {
    "errorOccurred": "An error occurred",
    "optional": "Optional",
    "phoneHelpText": "International format, ex: +41 79 123 45 67",
    "selectFile": "Select file"
  },
  "free": "Free",
  "guard": {
    "insufficientPermissions": "Your access level is insufficient to access this page.",
    "notLoggedIn": "You must sign in to access this page."
  },
  "help": {
    "title": "Help"
  },
  "helpBox": {
    "pricesMayVary": "Prices can be different base on the next step chosen date."
  },
  "helpText": {
    "actualFreeTimeSlotFirstBooking": "At any time, your calendar is locked for clients for {amount} minutes",
    "associations": "Each service can be done by some employees and some workplaces. You can define it here.",
    "availableBookingsInterval": "[Ex. 15] The system will propose a booking every 15 minutes.",
    "bookingSlotsPropositionInterval": "Booking will stat at [Ex. 5] 5', 10', 15', ... or [Ex. 15] 15', 30' 45', ...",
    "cancellationNotice": "Clients will only be able to cancel appointments scheduled in more than {amount} hours",
    "category": "Should your service category be missing, please contact our support service",
    "clientExitDuration": "After each appointment, the system gives you {amount} minutes to tidy up and cash your client",
    "closedFrom": "An open location must have this field empty",
    "comment": "This comment is shared with the customer",
    "companyName": "Offcial name of your company as registered",
    "emailReminderOffset": "An email reminder will be sent {amount} hours before the appointment",
    "favoriteEmployee": "Priority employee",
    "favoriteEmployeeOnly": "When this box is checked, only propositions with the preferred employee are returned.",
    "fixedDuration": "Service duration will always be the base one, without adaptation to the customer.",
    "locationName": "Public use",
    "locationShortName": "Private use",
    "numberOfVisitForVoucher": "After {amount} paid appointments, the customer receives a loyalty voucher",
    "pictureMinimumSize": "200 x 200 pixels minimum image size ",
    "pointsPerChfConversion": "The customer receives CHF 1 in loyalty for every CHF {amount} spent on his reservations",
    "price": "You can't modify the present price. To change it, you need to add a new price available at a future date.",
    "privateComment": "This note is not visible by the customer",
    "publicName": "This name will be the one used on the public pages. Your legal name will not be used.",
    "serviceDuration": "Service duration is adapted for every customer. The given duration will only be used the first time or if you check \"Fixed duration\" below.",
    "slug": "Text used in the url",
    "smsReminderOffset": "An sms reminder will be sent {amount} hours before the appointment",
    "uidNumber": "Switzerland only",
    "uniqueName": "Name must be unique",
    "voucher": "Voucher unique identifier composed of 8 letters"
  },
  "home": {
    "button": {
      "contactUs": "Contact us",
      "demo": "Ask for a demo",
      "discoverOurPrices": "Discover our price",
      "freeTrial": "Get free trial",
      "subscribe": "Subscribe",
      "takeALook": "Take a look"
    },
    "homeAppointment": {
      "resources": "All the resources needed will always be correctly planned and you will only have to focus on your job, delivering the best services.",
      "setUp": "Set up your {weeezy} account and your customers will be able to book your services online.",
      "title": "Open your services to the world"
    },
    "homeBasicAdvanced": {
      "complex": {
        "text": "Every employee has its own services, can be planned in different locations and share workplaces and machines.",
        "title": "Complex"
      },
      "easy": {
        "text": "All employees do the same service in one location using their own workplace.",
        "title": "Easy"
      },
      "paragraphe": "{weeezy} can deal with very easy setups to very complex ones. You can easily manage complexity and forget about planning !",
      "title": "Basic to advanced needs"
    },
    "homeFeatures": {
      "homeCards": {
        "customersRelationship": {
          "text": "Your customers have no secrets for you, keep track of their appointments and payments.",
          "title": "Customers Relationship"
        },
        "employeesSchedules": {
          "text": "Easily plan your employees months in advance with our advanced scheduling tool.",
          "title": "Employees' Schedules"
        },
        "exhaustiveCalendar": {
          "text": "A mulifaceted calendar to allow you to view your work, your schedule or your team.",
          "title": "Exhaustive Calendar"
        },
        "servicesManagement": {
          "text": "Set up your services and connect them to your resources for optimal appointments.",
          "title": "Services Management"
        }
      },
      "text": "{weeezy} has basic features to allow you and your customers to flawlessly book services.",
      "title": "Setting up {weeezy} is simple"
    },
    "homeOtherFeatures": {
      "homeCards": {
        "giftVouchers": {
          "text": "Creating and paying with gift vouchers is a breeze with our simple voucher tool.",
          "title": "Gift Vouchers"
        },
        "loyaltyManagement": {
          "text": "Reward your customers using our hasslefree and flexible loyalty program.",
          "title": "Loyalty Management"
        },
        "multipleLocations": {
          "text": "Allocate your resources and services across all your locations.",
          "title": "Multiple Locations"
        },
        "priorityManagement": {
          "text": "Decide who should be planned first on a service when available and who comes next.",
          "title": "Priority Management"
        },
        "reactiveSchedule": {
          "text": "Say how you want your day and let us schedule it for you based on your appointments.",
          "title": "Reactive Schedules"
        },
        "sharedResources": {
          "text": "Make sure a service has always the resources it needs when needed even if it is shared.",
          "title": "Shared Resources"
        }
      },
      "paragraphe": "{weeezy} gives you full access to advanced features should you need them!",
      "title": "Advanced features"
    },
    "homePrice": {
      "priceCard": {
        "3Months": "3 months free trial",
        "EasyToUse": "Easy to use",
        "allFeatures": "Access to all features",
        "billedAnnualy": "Licence billed annually only",
        "emailAndSlack": "Email and Slack for free",
        "muchMore": "And much, much more...",
        "oneSolution": "One solution that fits all your needs",
        "per": "per employee, per month",
        "smsCost": "0.15 per sms",
        "smsReminder": "SMS reminder",
        "title": "Our price"
      }
    },
    "homePrices": {
      "demoFirst": {
        "text": "Ask for a demo and we will plan a virtual meeting to show you our amazing tool.",
        "title": "Demo First?"
      },
      "freeTrial": {
        "text": "Create your account, set it up and try it for 3 months without having to add any payment information.",
        "title": "Free trial"
      }
    },
    "homeTimeMoney": {
      "missCustomer": {
        "answering": "You can be starting a business or be a long time success, answering to all your customers is almost impossible.",
        "title": "Never miss a customer again",
        "withWeeezy": "With {weeezy}, your customers can always book with you and they will never have to wait for you to be available."
      },
      "saveTime": {
        "text": "Save the time you usually spend to plan your customers appointments and only focus on the delivered services and your expertise.",
        "title": "Save time and money"
      }
    },
    "homeTitle": {
      "text": "A cloud app to help you manage your services, agenda and allow your customers to book online",
      "title": "All-in-1 for scheduled services"
    }
  },
  "invoiceAddModal": {
    "editInfo": "To edit an existing invoice, you must delete it and create a new one.",
    "title": "New Invoice"
  },
  "invoiceStatus": {
    "open": "Unpaid",
    "overpaid": "Overpaid",
    "paid": "Paid",
    "partial": "Partially paid"
  },
  "invoiceViewModal": {
    "title": "Invoice #"
  },
  "invoices": {
    "none": "No invoice",
    "title": "Invoice|invoices"
  },
  "label": {
    "actualFreeTimeSlotFirstBooking": "Calendar lock duration",
    "actualPrice": "Present price",
    "address": "Address",
    "addressComplement": "Additional address information",
    "all": "All",
    "allFeminine": "All",
    "allPaymentMethod": "All payment methods",
    "allowedServices": "Services autorisés",
    "amount": "Amount",
    "append": {
      "boxes": "boxes",
      "hours": "hours",
      "minutes": "minutes",
      "mn": "mn",
      "month": "month",
      "points": "points",
      "visits": "appointments"
    },
    "availableBookingsInterval": "Appointments proposals frequency",
    "balance": "Balance payable",
    "baseDuration": "Base duration",
    "birthdate": "Birthdate",
    "bookingSlotsPropositionInterval": "Booking precision",
    "break": "Break duration",
    "calendarColor": "label.calendarColor",
    "canCreateBookingsOutOfTimetables": "Can create bookings out of timetables",
    "canSetOwnTimetables": "Can set his own timetables",
    "cancellationNotice": "Cancellation notice",
    "capacityThreshold": "Block degree of filling before opening another block",
    "card": "Credit/Debit card",
    "cash": "Cash",
    "category": "Category",
    "changeValidFrom": "Change valid from",
    "city": "City",
    "clientExitDuration": "Tidying duration",
    "comment": "Comment",
    "companyName": "Company name",
    "country": "Country",
    "created": "Created on",
    "customer": "customer | customers",
    "customerName": "Customer's name",
    "date": "Date",
    "day": "Day",
    "description": "Description",
    "disabled": "Disabled",
    "discount": "Discount",
    "displayType": "Display mode",
    "duration": "Duration",
    "email": "E-mail address",
    "emailDefaultLanguage": "Email default language",
    "emailReminderOffset": "Email reminder notice",
    "emailReminderSwitchOff": "Switch email reminder on",
    "emailReminderSwitchOn": "Email reminder switched on",
    "employee": "Employee",
    "enabled": "Enabled",
    "end": "End",
    "eventDetails": "Private event",
    "favoriteEmployee": "Preferred employee",
    "favoriteEmployeeOnly": "Only preferred employee",
    "firstname": "First name",
    "fixedDuration": "Fixed duration",
    "flexible": "Flexible",
    "flexibleTimetable": "Flexible timetable",
    "from": "Start",
    "gender": "Title",
    "genderOther": "Other",
    "gift": "Gift voucher | Gift voucher | Gift vouchers",
    "homePhone": "Private phone",
    "lastname": "Name",
    "location": "Location",
    "logo": "Company logo",
    "machineModel": "Model",
    "maxEnd": "Latest allowed end of day",
    "median": "Median",
    "method": "Method",
    "minStart": "Earliest allowed start of day",
    "mobilePhone": "Private mobile phone",
    "mobileProPhone": "Professional mobile phone",
    "more": "More",
    "mr": "Mr",
    "mrs": "Mrs",
    "name": "Name",
    "newPrice": "New price",
    "no": "No",
    "noImagesAvailable": "No images available",
    "notFlexibleTimetable": "Static timetable",
    "number": "Number",
    "numberOfVisitForVoucher": "Number of paid bookings",
    "ownCategory": "I will be with",
    "password": "Password",
    "paymentMethod": "Payment method",
    "picture": "Company photos",
    "planning": "Planning",
    "pointsPerChfConversion": "Loyalty ratio",
    "possibleCategories": "I potentially need",
    "postcard": "Postcard",
    "preference": "Preferences",
    "price": "Price",
    "privateComment": "Private note",
    "publicName": "Public name",
    "quantity": "Quantity",
    "reason": "Reason",
    "region": "Region",
    "role": "Role",
    "service": "Service",
    "serviceNameOrNumber": "Service name or number",
    "servicePart": {
      "duration": "Duration",
      "start": "Minutes from beginning"
    },
    "shortName": "Short name",
    "smsReminderOffset": "Sms reminder notice",
    "smsReminderSwitchOff": "Switch sms reminder on",
    "smsReminderSwitchOn": "Sms reminder switched on",
    "special": "Special",
    "standardDuration": "Base duration",
    "start": "Start",
    "startOfDay": "Start of day",
    "step": "Step",
    "subtotal": "Subtotal",
    "summary": "Summary",
    "time": "Time",
    "timetablesEnabled": "Timetables",
    "total": "Total",
    "totalTimeSlot": "",
    "uidNumber": "UID Number",
    "unavailable": "Off",
    "uniqueIdentifier": "Unique identifier",
    "unitPrice": "Unit Price",
    "until": "Until",
    "username": "Username",
    "uuid": "Unique identifier",
    "valid": "Valid",
    "validFrom": "Valid from",
    "validUntil": "Valid until",
    "validity": "Validity",
    "value": "Value",
    "verified": "Verified",
    "week": "Week",
    "wording": "Wording",
    "workPhone": "Professional phone",
    "yes": "Yes",
    "zip": "Zip code",
    "zoom": "Zoom",
    "": ""
  },
  "location": {
    "color": "Color",
    "nameHint": "For internal use only.",
    "shortNameHint": "5 chars max (internal usage only)."
  },
  "locationForm": {
    "workplaces": {
      "label": "Workplaces"
    }
  },
  "locations": {
    "addInformation": "A location is one of the addresses where you offer your services.",
    "address": "Address",
    "afterClosedFromNotice": "This location is closed. Should you want to reopen it, please click on the link below. Should you want to delete it, please wait until the closing date is past.",
    "afterClosedFromNoticeTitle": "Location closed since the {data}",
    "beforeClosedFromNotice": "This location is closed. Should you want to reopen it, please click on the link below. Should you want to delete it, please wait until the closing date is past.",
    "beforeClosedFromNoticeTitle": "Location closed from the {data}",
    "city": "City",
    "closeFrom": "Close",
    "closed": "Closed",
    "closedDates": {
      "addClosedDate": "Add closed date",
      "closedFrom": "Close temporarily or definitively the location from a given date. You'll be able to delete the location when the given date is passed.",
      "date": "Date",
      "day": "Day",
      "description": "Please indicate any public holidays or other dates when this location is closed, this will prevent appointments from being made.",
      "reason": "Reason"
    },
    "closedFrom": "Plan closing",
    "closedFromAlert": "This location is closed from the {0}.",
    "closedFromAlertReOpen": "Click here to reopen it.",
    "name": "Name",
    "noRegion": "Without region",
    "open": "Open",
    "reopen": "Reopen",
    "zip": "Zip"
  },
  "login": {
    "connectedAs": "You are connected as: ",
    "createAccount": "Sign up",
    "forgotPassword": "Password forgotten?",
    "hasAccount": "I have an account",
    "noAccount": "You do not have an account ?",
    "title": "Sign in",
    "username": "Username",
    "usernameOrEmail": "Username or e-mail"
  },
  "machines": {
    "addModel": "Add a resource model",
    "addRessource": "Add a resource",
    "associatedService": "Services using this resource",
    "editModel": "Edit a resource model",
    "emptyDataset": "No material resources",
    "modelMisconfigured": "",
    "search": {
      "placeholder": "Resource name"
    }
  },
  "monthlyStats": {
    "bookingStatus": "Booking Status",
    "canceled": "Canceled",
    "confirmed": "Confirmed",
    "customerTypes": "Customer Types",
    "enableComparison": "Enable Comparison",
    "executed": "Completed",
    "female": "Female",
    "genderDistribution": "Gender Distribution",
    "male": "Male",
    "month": "Month",
    "newCustomers": "New Customers",
    "noShow": "No Show",
    "open": "Open",
    "other": "Other",
    "period1": "Period 1",
    "period2": "Period 2",
    "recurringCustomers": "Recurring Customers",
    "totalBookings": "Total Bookings",
    "totalCustomers": "Total Customers",
    "totalUniqueCustomers": "Total Unique Customers",
    "year": "Year"
  },
  "stats": {
    "allEmployees": "All employees",
    "allServices": "All services",
    "annual": "Annual",
    "bookingsCount": "Bookings",
    "bookingStatus": "Booking Status",
    "canceled": "Canceled",
    "confirmed": "Confirmed",
    "customersCount": "Customers",
    "customerTypes": "Customer Types",
    "employee": "Employee",
    "employeeActivity": "Employee Activity",
    "employeeServices": "Services performed",
    "enableComparison": "Enable Comparison",
    "eventsCount": "Services",
    "executed": "Completed",
    "female": "Female",
    "formerEmployee": "former employee",
    "genderDistribution": "Gender Distribution",
    "leastUsedServices": "Least Used Services",
    "male": "Male",
    "month": "Month",
    "monthly": "Monthly",
    "mostUsedServices": "Most Used Services",
    "neverUsedServices": "Never Used Services",
    "newCustomers": "New Customers",
    "noComparisonData": "No comparison data available",
    "noDecliningServices": "No declining services",
    "noEmployeeActivity": "No activity",
    "noGrowingServices": "No growing services",
    "noServicesUsed": "No services",
    "noShow": "No Show",
    "open": "Open",
    "other": "Other",
    "period1": "Period 1",
    "period2": "Period 2",
    "periodType": "Period Type",
    "recurringCustomers": "Recurring Customers",
    "resetToNow": "Reset",
    "serviceName": "Service",
    "serviceNumber": "No.",
    "serviceUsage": "Service Usage",
    "showAllServices": "All services",
    "topDecliningServices": "Top Declining Services (>50 usage)",
    "topGrowingServices": "Top Growing Services (>50 usage)",
    "totalBookings": "Total Bookings",
    "totalCustomers": "Total Customers",
    "totalUniqueCustomers": "Total Unique Customers",
    "unnamedService": "Service without article",
    "usageCount": "Usage",
    "workedHours": "Hours",
    "year": "Year"
  },
  "multiselect": {
    "listEmpty": "There are no other element available",
    "maxElements": "Maximum of <max> options selected. First remove a selected option to select another.",
    "select": "Select"
  },
  "myAccount": {
    "EmailLink": "Get my email validation link",
    "EmailValidationExplanation": "Confirming your e-mail you'll be able to recover your customers accounts created by vendors, to recover your password or to receive notifications for your next events.",
    "EmailValidationHow": "To confirm your email, check your inbox and click on the link in the email we sent you.",
    "EmailValidationLink": "To receive a new e-mail validation link, please click on that link :",
    "EmailValidationTitle": "Confirm my email",
    "NoVendor": "No active vendors",
    "account": "My customer account at",
    "contactUs": "",
    "information": "",
    "loadingError": "An error occurred on loading the customer account.",
    "makeAppointment": "Make an appointment",
    "makeAppointmentByEmail": "",
    "makeAppointmentByPhone": "",
    "makeFirstAppointment": "Make my first appointment",
    "tabs": {
      "myInfo": "My Personal Details"
    }
  },
  "myAccountEdit": {
    "success": "Your account was modified",
    "title": "My personal details"
  },
  "name": {
    "article": "Item | Item | Items",
    "association": "Association | Assocations",
    "day": "Day",
    "fidelityVoucher": "Loyalty voucher | Loyalty voucher | Loyalty vouchers",
    "payment": "Payment | Payment | Payments",
    "planning": "Planning",
    "service": "Service | Service | Services",
    "slug": "Slug",
    "voucher": "Gift card | Gift card | Gift cards",
    "week": "Week"
  },
  "navbar": {
    "about": "About us",
    "admin": "Business workspace",
    "becomeVendor": "Register your company",
    "bookNow": "Book now",
    "features": "",
    "industries": "",
    "language": "Language",
    "login": "Sign in",
    "logout": "Sign out",
    "myAccount": "My Account",
    "myAccountEdit": "Personal information",
    "product": "Product",
    "settings": "Settings"
  },
  "onboarding": {
    "addLocationHelpText": "Welcome to Weeezy !\nYou need to configure your company account. We are going to guide you and you can follow the purple dot on the left menu!\nFirst, let's create a location.",
    "addServiceHelpText": "Congratulations. your first location has been created!\nNow we need to create your first service.",
    "addTimetableHelpText": "Almost there!\nLast but not least, you need to add your schedule.",
    "completeModalText1": "You ended the basic company account configuration.",
    "completeModalText2": "You can continue configuring the account by adding employees, services, existing customers and discovering all Weeezy's other features.",
    "completeModalTitle": "Congratulations!",
    "helpText": "Your account is not yet active or visible to the public. You must first complete the setup.",
    "liveModeButton": "Activate my account",
    "liveModeHelpText": "When you're done configuring your account, you can activate your account once and for all.",
    "liveModeTitle": "Ready ?",
    "setupTitle": "Setting up your account",
    "toLocations": "To the locations",
    "toServices": "To the services",
    "toTimetables": "To the timetables"
  },
  "openBookings": {
    "none": "No booking planned",
    "title": "Next bookings | Next bookings"
  },
  "pagination": {
    "total": "Total:"
  },
  "passwordInput": {
    "forgotPassword": "Forgot your password ?",
    "hint": "The password must be at least 6 characters long",
    "label": "Password"
  },
  "placeholder": {
    "addDescription": "Add a description",
    "addPrice": "Add price",
    "addQuantity": "Add quantity",
    "customer": "Customer's lastname or firstname ",
    "employee": "Employee's lastname or firstname ",
    "location": "Location's name",
    "region": "Region name",
    "searchServices": "Name or service #",
    "selectDate": "Select date",
    "service": "Name or number of service",
    "voucherCode": "Voucher code"
  },
  "privateEvent": {
    "addTitle": "Add private event",
    "editTitle": "Edit private event",
    "summary": "Title"
  },
  "regions": {
    "addRegion": "New region",
    "editRegion": "Edit region"
  },
  "reports": {
    "difference": "",
    "download": {
      "csv": "",
      "excel": ""
    },
    "selected": "",
    "stats": "",
    "total": ""
  },
  "resetPassword": {
    "title": "New password"
  },
  "resetPasswordConfirmation": {
    "description": "Please check your inbox and follow the e-mail's instructions to reset your password.",
    "title": "An e-mail was sent at"
  },
  "resource": {
    "added": "New element added: {0}",
    "deleted": "Resource deleted",
    "edited": ""
  },
  "schedule": {
    "dateException": "Special",
    "notPlanned": "Off"
  },
  "selectInput": {
    "emptyLabel": "Please select"
  },
  "serviceForm": {
    "advanced": {
      "helpText": "",
      "parts": {
        "add": "Add customer attention",
        "addInter": "Add intermediary moment",
        "delete": "Delete all moment with customer",
        "removeInter": "Remove this intermediary moment",
        "title": "Moments with the customer"
      },
      "title": "Advanced parameters"
    },
    "associatedServices": {
      "helpText": "When customers choose this service, the following services will be highlighted.",
      "label": "Associated services",
      "labelTooltip": "When customers choose this service, the following services will be put forward."
    },
    "basics": {
      "title": "Master data"
    },
    "duration": {
      "currentBookingsWillBeKept": "The modified duration will be effective for new bookings only.",
      "title": "Duration"
    },
    "machines": {
      "label": "Material resources"
    },
    "notPreferredEmployees": {
      "currentBookingsWillBeKept": "Appointments scheduled with this employee will be kept.",
      "label": "Non priority employees",
      "labelTooltip": "When making an appointment, a NON PRIORITY employee will be proposed only if no priority employee is available."
    },
    "preferredEmployees": {
      "currentBookingsWillBeKept": "If appointments have been made with this employee, they will be kept.",
      "label": "Priority employees",
      "labelTooltip": "When making an appointment, a PRIORITY employee will always be proposed to perform this treatment if available."
    },
    "priceCantBeModified": "The price cannot be changed after saving.",
    "prices": {
      "title": "Acutal and future prices"
    },
    "workplaces": {
      "label": "Workplaces"
    }
  },
  "services": {
    "addInformation": "Customer wil be able to book one or more services.",
    "childServicesModal": {
      "title": "Complementary services"
    },
    "selectServices": "Select a service | Select services",
    "sortServicePerformedOrder": "Execution order",
    "sortServicePerformedOrderComment": "Services are ordered in bookings following the order below. A service above another one is considered to be executed before the one below. Order is very important when a booking is split between more than one employee."
  },
  "settings": {
    "integrations": {
      "addApp": "Get the Weeezy app on your Slack Workspace :",
      "appAdded": "You have integrated Slack and notifications are sent to <b>{channel}</b> channel in your <b>{team}</b> team.",
      "slackMessage": "Get your bookings notification on Slack"
    },
    "limit": {
      "alert": "Daily limitation is not taken into account on booking entered directly in your calendar.",
      "title": "Daily services limitations",
      "perDay": "x / day"
    },
    "maxServicesPerDay": "",
    "navbar": {
      "admin": "Admin space",
      "becomeVendor": "Sign up my company",
      "bookNow": "Book now",
      "fidelity": "Loyalty",
      "general": "Company",
      "images": "Images",
      "integrations": "Integrations",
      "language": "Language",
      "loyalty": "Loyalty",
      "public": "Search",
      "settings": "Bookings"
    },
    "visibility": {
      "limit": "Open online booking for the next",
      "title": "Limit customers ability to book in the future"
    }
  },
  "sidebar": {
    "calendar": "Calendar",
    "cashClosing": "Cash Closing",
    "closedDates": "Business Holidays",
    "config": "Configuration",
    "customers": "Customers",
    "employees": "Employees",
    "giftCards": "Gift cards",
    "locations": "Locations",
    "monthlyStats": "Monthly Statistics",
    "myVendor": "My company",
    "planning": "Planning",
    "regions": "Regions",
    "reports": "Reports",
    "resources": "Resource | Resources",
    "schedules": "Timetables",
    "services": "Services",
    "sharedResources": "Resource | Resources",
    "stats": "Statistics",
    "vendorBookings": "Bookings",
    "workplaces": "Workplace | Workplaces"
  },
  "signUp": {
    "title": "Create your account",
    "usernameHint": "It is also possible to use a username to login."
  },
  "signUpConfirmation": {
    "description": "Please check your inbox and follow the e-mail's instructions to complete your sign up.",
    "title": "An activation link was sent to"
  },
  "timetable": {
    "add": "Add timetable",
    "block": "Block",
    "break": "Break",
    "capacityThreshold": "A first block must be filled at {threshold}% for the next to open.",
    "dateException": "Special timetable",
    "duplicate": "Duplicate timetable",
    "edit": "Edit timetable",
    "editInfo": {
      "validFromIsToday": "Modifying this timetable will create a new timetable available from today."
    },
    "from": "from",
    "max_end": "End of day until",
    "min_start": "Start of day from",
    "until": "until",
    "willOverride": "You already have a timetable from {validFrom}. Should you save, you'll replace that timetable."
  },
  "timetableExceptions": {
    "add": "Add special timetable",
    "duplicate": "Duplicate special timetable",
    "edit": "Modify special timetable",
    "empty": {
      "future": "No future special timetables",
      "past": "No special timetables"
    },
    "future": "Future",
    "info": {
      "replace": "You already a special timetable planned on {date}. Saving will override this special timetable."
    },
    "name": "Special timetable",
    "onThe": "on the",
    "past": "Actual and Past",
    "title": "Special"
  },
  "timetables": {
    "actual": "Actual timetable",
    "available": "Available",
    "block": "Working block",
    "dateException": "Special timetable",
    "empty": {
      "future": "No future timetable",
      "past": "No timetables"
    },
    "from": "From:",
    "fromThe": "from the",
    "future": "Coming",
    "mayUse": "May use",
    "name": "Recurring timetable",
    "notAvailable": "Off",
    "past": "Actual and Past",
    "repeatForTheFollowingDays": "Repeat for the following days",
    "title": "Recurring",
    "total": "Hours planned:",
    "unknownLocation": "Unknown",
    "with": "With"
  },
  "toast": {
    "changesSaved": "Data saved.",
    "changesSavingError": "Error saving data. The changes weren't saved ",
    "closedDateDeleted": "Closed date deleted",
    "copiedToClipboard": "The link has been copied to your clipboard.",
    "customerDeleted": "Customer has been deleted",
    "employeeDeleted": "Employee has been deleted",
    "eventDeleted": "Event successfully deleted.",
    "liveModeEnabled": "",
    "locationDeleted": "Location deleted",
    "machineDeleted": "Material resource deleted",
    "regionDeleted": "Region deleted",
    "serviceDeleted": "Service deleted",
    "timetableExceptionAdded": "Special timetable added",
    "timetableExceptionModified": "Special timetable modified",
    "validationErrors": "There are some errors on the form",
    "workplaceDeleted": "Workplace deleted."
  },
  "validation": {
    "afterTime": "The time must be after {time}",
    "alphaNumeric": "Must be alphanumeric",
    "decimal": "The value must be an amount",
    "divider": "The number must be a multiple of {value}",
    "double": "The value must be a number with 2 decimals",
    "excluded": "Value must be different from {excluded}",
    "formHasErrors": "The form contains errors",
    "greaterThan": "Value must be greater than {value}",
    "invalidEmail": "Invalid e-mail",
    "invalidPhone": "Invalid phone, use the international format",
    "invalidTime": "Invalid time",
    "length": "Length required {length}",
    "maximumLength": "Maximum length {max}",
    "maximumValue": "Maximum value {max}",
    "minimumLength": "Minimum length {min}",
    "minimumValue": "Minimum value {min}",
    "numeric": "Value must be an integer",
    "otherField": "Both this field and {value} have to be empty or filled",
    "required": "Required",
    "sameOrAfterTime": "The time must be same or after {time}",
    "sameOrBeforeTime": "The time must be same or before {time}",
    "startMustBeBeforeEnd": "Start hour must be before end hour",
    "valueAlreadyRegistered": "{value} is already registered",
    "weakPin": "PIN too simple: avoid sequences and repeated digits."
  },
  "vendorBookings": {
    "allStatuses": "All statuses",
    "none": "No bookings",
    "title": "Bookings"
  },
  "vendorSignUp": {
    "generalSettings": {
      "bookingSettingsInformation": "By adjusting the general parameters, you decide how the bookings are going to be generated for your customers.",
      "employee": "Employee",
      "fidelity": "Loyalty Voucher Settings",
      "fidelityInformation": "Loyalty cards reward customers for reservations made and paid for. After a certain number of reservations that you can define, the customer receives a loyalty voucher. The value of this voucher depends on the total spent on your services divided by the loyalty ratio.",
      "location": "Location",
      "minutes": "Minutes",
      "remainingCredits": "You have {n} sms credit left | You have {n} sms credits left",
      "remainingCreditsZero": "You have not sms credit left. No sms can be sent!",
      "reminderTitle": "Appointment Reminders",
      "remindersInformation": "Choose below if you want to send sms or email reminders before appointment and their notice period.",
      "resources": "Resources",
      "service": "Service",
      "slack": "Slack Integration",
      "title": "General settings",
      "userAccount": "User account",
      "userAccountInfo": "To sign in your company account you need to create a Weeezy user. You'll be able to manage your company account.",
      "workingSchedule": "Working schedule"
    },
    "legalInfo": {
      "title": "Details"
    },
    "legalInformation": {
      "information": "Company information are not displayed on Weeezy's public pages. Your details allow us to contact you, to send you documents and to check your existence."
    },
    "publicInfo": {
      "galleryDragDrop": "Drag and drop your images or <span class=\"filepond--label-action\">Browse</span>",
      "galleryHelp": "Upload photos of your business that will be displayed on your public page.",
      "galleryHelpText": "Accepted formats: JPG, PNG. Maximum size: 5MB per file. Maximum 10 files.",
      "galleryLabel": "Business Photos",
      "logoDragDrop": "Drag and drop your logo or <span class=\"filepond--label-action\">Browse</span>",
      "logoHelp": "Upload your company logo that will be displayed on your public page.",
      "logoHelpSvg": "Prefer an SVG logo.",
      "logoHelpText": "Accepted formats: JPG, PNG, WebP, SVG. Maximum size: 3MB. Single file only.",
      "logoHelpWhiteBg": "If you upload a logo with white borders, they will be automatically removed.",
      "logoLabel": "Company Logo",
      "pictureViaEmail": "Send us your pictures in JPG ou PNG (800px x 1200px) format and you logo in PDF / SVG ou PNG (800px x 1200px) format by email at",
      "title": "Public information"
    },
    "publicInformation": {
      "information": "These details will be used on Weeezy's directory. The better the information, the better people can search for you."
    },
    "title": "Become a vendor"
  },
  "voucher": {
    "addTitle": "Add a gift card",
    "balance": "Balance",
    "confirmDelete": "Please confirm the deletion of the voucher with reference {uuid} by clicking on the \"Delete\" button below",
    "deletionConfirmed": "Voucher card was deleted",
    "notValidSince": "Not valid since",
    "onlyLetters": "Letters only",
    "report": "Copy on voucher",
    "uuidText": "Find below the voucher unique identifier to copy on the paper voucher:",
    "validUntil": "Valid until"
  },
  "word": {
    "booking": "Booking",
    "free": "Free",
    "invoice": "Invoice|invoices",
    "line": "Line"
  },
  "workplaceForm": {
    "authorizedServices": {
      "label": "Authorized services",
      "labelTooltip": "When the appointment is made, these services will be offered to the client as a complement."
    },
    "color": "Calendar color (RGB)",
    "notPreferredEmployees": {
      "label": "Non priority employees",
      "labelTooltip": "When making an appointment, a NON PRIORITY employee will be proposed only if no priority employee is available."
    },
    "preferredEmployees": {
      "label": "Priority employees",
      "labelTooltip": "When making an appointment, a PRIORITY employee will always be proposed to perform this treatment if available."
    }
  },
  "employeeMembership": {
    "accessRemoved": "The employee no longer has admin access.",
    "accessUntilDeparture": "The employee keeps admin access until {date} at 11 pm.",
    "cancelDeparture": "Cancel departure",
    "cancelDepartureConfirm": "Cancel the departure of {name}?",
    "deleteConfirm": "Permanently delete {name}?",
    "departureCancelled": "Departure cancelled",
    "departureIntro": "Pick {name}'s last working day. Their admin access stays open until 11 pm that day.",
    "departureRecorded": "Departure recorded",
    "departureRequirements": {
      "title": "Before recording the departure, after their last day you must:",
      "timetable": "empty their timetable",
      "appointments": "move their appointments",
      "openings": "remove their exceptional openings"
    },
    "departureTitle": "Departure of {name}",
    "invitationSent": "Invitation sent to {email}",
    "invite": "Invite",
    "inviteHelp": "A link valid for 7 days is sent to this address to create an account or link an existing one. Sending again replaces the previous invitation.",
    "inviteTitle": "Invite {name}",
    "lastDay": "Last working day",
    "leavingOn": "Last day on {date}",
    "leftOn": "Left on {date}",
    "noAccount": "No account",
    "recordDeparture": "Record departure",
    "showDeparted": "Show former employees"
  },
  "spaces": {
    "title": "Choose a space",
    "help": "Your account gives access to several spaces. Choose the one you want to work in.",
    "customer": "My customer account",
    "switch": "Switch space",
    "roles": {
      "2": "Staff",
      "3": "Admin"
    }
  },
  "invitation": {
    "title": "Invitation",
    "message": "{vendor} invites you to join their team as {name}.",
    "invalid": "This invitation has expired or has already been used. Ask your employer for a new one.",
    "signInFirst": "Sign in with your account, or create one, to accept the invitation.",
    "accept": "Accept the invitation"
  },
  "notFound": {
    "text": "This address does not match any page. Check it or use the menu.",
    "title": "Page not found",
    "publicText": "The address may be mistyped, or the link has changed. Use the menu."
  }
}
